/* ReviewAndInstall.tsx generated by @compiled/babel-plugin v0.36.0 */
/* eslint-disable max-lines-per-function */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { useGetAppDetailsFromSearch } from '@atlassian/mpac-app-listing';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { AnalyticsAndLogs, AppScopes, checkIfGlobalLogsAndAnalyticsAreEnabled, DataEgress, findWebTriggerRule, getAppRoaStatus, getCategorizedEgressAndAnalytics, InstallableAppPrivacyInformation, INSTALLATION_BLOCKING_APIS, MultiInstancePricingSectionMessage, ScreenTitle, SelectedEdition, useLatestVersionDetailsAndInstallationConfig } from '@atlassian/mpac-installation';
import { MarketplacePartnerType } from '@atlassian/mpac-types/graphql-gateway-types';
import { InstallDialogEditionHeader as AppHeader } from '@atlassian/mpac-ui';
import { appSupportsEditions } from '@atlassian/mpac-utils';
import { useEffect } from 'react';
import { makeAppHeaderDetails } from '../../../types/AppHeader';
import Pricing from '../../common/Pricing/container/PricingContainer';
import { isInstallableAppCloudFortified } from '../../InstallAppDialog/utils/installableApp';
import { useLinkTemplates } from '../hooks/useLinkTemplates';
import { SandBoxSectionMessage } from '../utils/SandBoxSectionMessage';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _8 = "._1bahesu3{justify-content:flex-end}";
const _7 = "._19pk1ejb{margin-top:var(--ds-space-300,24px)}";
const _6 = "@media (min-width:48rem){._19wgxy5q{gap:var(--ds-space-400,2pc)}}";
const _5 = "._2lx21bp4{flex-direction:column}";
const _4 = "._1e0c1txw{display:flex}";
const _3 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const _2 = "@media not all and (min-width:48rem){._1s6bukr8{margin:var(--ds-space-negative-400,-2pc)}}";
const _ = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const pricingContainerStyles = null;
const reviewAndInstallScreenStyles = null;
const reviewAndInstallContentStyles = null;
const renderMILPricingSectionMessage = (showEditions, baseData, appHasMultiInstanceEntitlement, selectedEditionType, enterprisePlanPurchased) => {
  return showEditions && selectedEditionType && enterprisePlanPurchased && appHasMultiInstanceEntitlement && /*#__PURE__*/_jsx(MultiInstancePricingSectionMessage, {
    eligibleOfferings: baseData.eligibleOfferings,
    enterprisePlan: enterprisePlanPurchased,
    selectedPlan: selectedEditionType,
    isStepReviewAndInstall: true
  });
};

// eslint-disable-next-line max-lines-per-function
export const ReviewAndInstall = _ref => {
  var _baseData$hostData, _baseData$hostData$ho, _installableApp$marke, _installableApp$marke2, _baseData$installMode, _baseData$installMode2, _baseData$installMode3;
  let {
    baseData,
    appInstallConfig,
    appKey,
    hostCloudId: cloudId,
    updateErrAndLoadingState,
    editions,
    selectedEditionType,
    enterprisePlanPurchased,
    appHasMultiInstanceEntitlement
  } = _ref;
  const links = useLinkTemplates({
    adminHubBaseUrl: appInstallConfig.adminHubBaseUrl,
    mpacBaseUrl: appInstallConfig.mpacBaseUrl,
    mpacCdnBaseUrl: appInstallConfig.mpacCdnBaseUrl,
    macBaseUrl: appInstallConfig.macBaseUrl,
    wacBaseUrl: appInstallConfig.wacBaseUrl,
    atlassianCommunityBaseUrl: appInstallConfig.atlassianCommunityBaseUrl
  });
  const {
    enableSelfServeAppEditions
  } = useStatsig();
  const selfServeAppEditionsEnabled = enableSelfServeAppEditions();
  const showEditions = selfServeAppEditionsEnabled && appSupportsEditions({
    editions,
    billingSystem: (_baseData$hostData = baseData.hostData) === null || _baseData$hostData === void 0 ? void 0 : (_baseData$hostData$ho = _baseData$hostData.hostLicense) === null || _baseData$hostData$ho === void 0 ? void 0 : _baseData$hostData$ho.billingSystem
  });
  const {
    installMode,
    hostData: {
      hostLicense
    },
    scopesLookup,
    appIdentifier
  } = baseData;
  const appDetailsFromSearchResponse = useGetAppDetailsFromSearch({
    algoliaConfig: appInstallConfig.algoliaConfig,
    appKey
  });
  const {
    installableApp,
    installedApp
  } = installMode;
  const isConnectApp = installableApp === null || installableApp === void 0 ? void 0 : (_installableApp$marke = installableApp.marketplaceAppDetails) === null || _installableApp$marke === void 0 ? void 0 : _installableApp$marke.isConnectApp;
  const hostPricing = {
    pending: false,
    result: hostLicense,
    error: null
  };
  const result = useLatestVersionDetailsAndInstallationConfig({
    appKey: !isConnectApp ? appIdentifier.ari : '',
    cloudId,
    environmentKey: 'production',
    skipGlobalInstallationConfig: isConnectApp,
    skipLatestVersionAppDetails: isConnectApp,
    gqlGatewayUrl: appInstallConfig.graphQLGatewayUrl
  });
  const {
    latestVersionAppDetailsResult,
    latestVersionAppDetailsError,
    latestVersionAppDetailsLoading,
    globalInstallationConfigResult,
    globalInstallationConfigError,
    globalInstallationConfigLoading
  } = result;
  useEffect(() => {
    const errorOrLoading = globalInstallationConfigError || globalInstallationConfigLoading;
    updateErrAndLoadingState(INSTALLATION_BLOCKING_APIS.INSTALLATION_CONFIG, !!errorOrLoading);
  }, [globalInstallationConfigError, globalInstallationConfigLoading, updateErrAndLoadingState]);
  useEffect(() => {
    const errorOrLoading = latestVersionAppDetailsError || latestVersionAppDetailsLoading;
    updateErrAndLoadingState(INSTALLATION_BLOCKING_APIS.LATEST_VERSION_DETAILS, !!errorOrLoading);
  }, [latestVersionAppDetailsError, latestVersionAppDetailsLoading, updateErrAndLoadingState]);
  const {
    categorizedRemoteEgress,
    analyticsEgress,
    inScopeEUDForLatestVersion
  } = getCategorizedEgressAndAnalytics(latestVersionAppDetailsResult);
  const roaStatus = getAppRoaStatus(latestVersionAppDetailsResult);
  const isGlobalLogsAndAnalyticsEnabled = checkIfGlobalLogsAndAnalyticsAreEnabled(globalInstallationConfigResult);
  const hasWebTriggerEgress = findWebTriggerRule(latestVersionAppDetailsResult);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_ect418aq _1s6bukr8"]),
      children: [/*#__PURE__*/_jsx(ScreenTitle, {
        title: "Review and Install",
        stepInfo: "Step 2 of 2"
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_3, _4, _5, _6]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_zulp1ejb _1e0c1txw _2lx21bp4 _19wgxy5q"]),
          children: [/*#__PURE__*/_jsx(AppHeader, {
            appHeaderDetails: makeAppHeaderDetails(installableApp.marketplaceAppDetails, appDetailsFromSearchResponse),
            appIconLink: links.appIcon,
            appRatingLink: links.appRating,
            isAppCloudFortified: isInstallableAppCloudFortified(installableApp),
            openMarketplaceLinksInNewTab: true,
            isRunsOnAtlassianApp: !!roaStatus,
            bugBountyParticipant: (_installableApp$marke2 = installableApp.marketplaceAppDetails.programs) === null || _installableApp$marke2 === void 0 ? void 0 : _installableApp$marke2.bugBountyParticipant,
            headerInjection: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_7, _4, _8]
              }), /*#__PURE__*/_jsxs("div", {
                className: ax(["_19pk1ejb _1e0c1txw _1bahesu3"]),
                children: [editions && showEditions && selectedEditionType && /*#__PURE__*/_jsx(SelectedEdition, {
                  edition: selectedEditionType,
                  appPricingDetailsLink: links.appPricingDetails.expand({
                    appKey: (_baseData$installMode = baseData.installMode) === null || _baseData$installMode === void 0 ? void 0 : (_baseData$installMode2 = _baseData$installMode.installableApp) === null || _baseData$installMode2 === void 0 ? void 0 : (_baseData$installMode3 = _baseData$installMode2.marketplaceAppDetails) === null || _baseData$installMode3 === void 0 ? void 0 : _baseData$installMode3.key
                  })
                }), /*#__PURE__*/_jsx(Pricing, {
                  hostPricing: hostPricing,
                  appKey: installableApp.details.key,
                  links: links,
                  installedApp: installedApp,
                  paymentModel: installableApp.marketplaceAppDetails.paymentModel,
                  mpacBaseUrl: appInstallConfig.mpacBaseUrl,
                  eligibleForFreeOnSandbox: installableApp.eligibleForFreeOnSandbox,
                  cloudMigrationTrial: installableApp.cloudMigrationTrial,
                  editions: editions,
                  selectedEditionType: selectedEditionType,
                  eligibleOfferings: baseData.eligibleOfferings
                })]
              })]
            })
          }), showEditions && /*#__PURE__*/_jsx(SandBoxSectionMessage, {
            eligibleOfferings: baseData.eligibleOfferings,
            selectedEditionTypeValue: selectedEditionType || null
          }), renderMILPricingSectionMessage(showEditions, baseData, appHasMultiInstanceEntitlement, selectedEditionType, enterprisePlanPurchased), scopesLookup && /*#__PURE__*/_jsx(AppScopes, {
            graphQLGatewayUrl: appInstallConfig.graphQLGatewayUrl,
            appScopes: installableApp.scopes,
            updateErrAndLoadingState: updateErrAndLoadingState
          }), /*#__PURE__*/_jsx(DataEgress, {
            egresses: categorizedRemoteEgress,
            queryError: latestVersionAppDetailsError,
            roaStatus: roaStatus,
            hasWebtriggerEgress: hasWebTriggerEgress,
            isForgeApp: !isConnectApp
          }), /*#__PURE__*/_jsx(AnalyticsAndLogs, {
            analyticsEgress: analyticsEgress,
            isGlobalLogsAndAnalyticsEnabled: isGlobalLogsAndAnalyticsEnabled,
            inScopeEUDForLatestVersion: inScopeEUDForLatestVersion,
            roaStatus: roaStatus,
            links: links,
            isForgeApp: !isConnectApp,
            cloudId: cloudId,
            analyticsQueryError: latestVersionAppDetailsError,
            installConfigQueryError: globalInstallationConfigError
          }), /*#__PURE__*/_jsx(InstallableAppPrivacyInformation, {
            links: links,
            appName: installableApp.marketplaceAppDetails.name,
            partner: {
              name: installableApp.marketplaceAppDetails.vendor.name,
              type: installableApp.marketplaceAppDetails.vendor.vendorType === 'internal' ? MarketplacePartnerType.AtlassianInternal : null
            },
            privacyPolicyUrl: installableApp.marketplaceAppDetails.privacyPolicy,
            endUserLicenseAgreementUrl: installableApp.marketplaceAppDetails.eula,
            appIdentifier: baseData.appIdentifier
          })]
        })]
      })]
    })]
  });
};